import React, {useState} from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import Select from 'react-select';

function SearchBar(props) {
    
    const input = document.querySelector("#searchInput");

    const [selected, setSelected] = useState("");

    input?.addEventListener("keypress", function(event) {
        if (event.key === "Enter") {
            event.preventDefault();
            document.getElementById("searchBtn").click();
        }
    });
    
    const customDropDown = {
        control: (styles) => ({...styles, 
            backgroundColor:'#E3EAF9',
            height:'40px',
            width:'128px',
            border:'none',
            borderRadius: '8px 0 0 8px',
            cursor: 'pointer'
        }),
        option: (styles) => {
            return {...styles, 
                ':hover' : {
                    backgroundColor: '#97C5F9',
                    color: 'white'
                }
            };
        },
        valueContainer: (styles) => ({
            ...styles,
            fontSize: '18px',
            lineHeight: '28px',
            overflow: 'hidden'
        }),
        indicatorSeparator: (styles) => ({
            ...styles,
            color: '#9ca3af'
        }),
        multiValue: (styles) => ({
            ...styles,
            backgroundColor: '#3B8EED',
            color: 'white',
            borderRadius: '10px'
        }),
        multiValueLabel: (styles) => ({
            ...styles,
            color: 'white'
        }),
        multiValueRemove: (styles) => ({
            ...styles,
            color: 'white',
            ':hover' : {
                backgroundColor: '#97C5F9',
                color: 'black',
                borderRadius: '0px 10px 10px 0px'
            }
        }),
        dropdownIndicator: (styles) => ({
            ...styles,
            color: '#9ca3af'
        }),
        input: (styles) => ({
            ...styles,
            height: '32px'
        }),
        menu: (styles) => ({
            ...styles,
            maxHeight: '80px',
            height: 'auto',
            background: '#E3EAF9',
            border:'none',
            borderRadius: '0',
            fontSize: '18px',
            lineHeight: '28px',
            color: '#6B7280'
        }),
        menuList: (styles) => ({
            ...styles,
            background: '#E3EAF9',
            border:'none',
            borderRadius: '0',
            overflowY: 'auto',
            height: 'auto',
            maxHeight: '80px'
        }),
        placeholder: (styles) => ({...styles,
            fontSize: '18px',
            lineHeight: '28px',
            color: '#9ca3af'
        })
    }

    const customDropDownMobile = {
        control: (styles) => ({...styles, 
            backgroundColor:'#E3EAF9',
            height:'40px',
            width:'95px',
            border:'none',
            borderRadius: '8px 0 0 8px',
            cursor: 'pointer'
        }),
        option: (styles) => {
            return {...styles, 
                ':hover' : {
                    backgroundColor: '#97C5F9',
                    color: 'white'
                }
            };
        },
        valueContainer: (styles) => ({
            ...styles,
            fontSize: '14px',
            lineHeight: '20px',
            overflow: 'hidden'
        }),
        indicatorSeparator: (styles) => ({
            ...styles,
            color: '#9ca3af'
        }),
        multiValue: (styles) => ({
            ...styles,
            backgroundColor: '#3B8EED',
            color: 'white',
            borderRadius: '10px'
        }),
        multiValueLabel: (styles) => ({
            ...styles,
            color: 'white'
        }),
        multiValueRemove: (styles) => ({
            ...styles,
            color: 'white',
            ':hover' : {
                backgroundColor: '#97C5F9',
                color: 'black',
                borderRadius: '0px 10px 10px 0px'
            }
        }),
        dropdownIndicator: (styles) => ({
            ...styles,
            color: '#9ca3af'
        }),
        input: (styles) => ({
            ...styles,
            height: '32px'
        }),
        menu: (styles) => ({
            ...styles,
            maxHeight: '80px',
            height: 'auto',
            background: '#E3EAF9',
            border:'none',
            borderRadius: '0',
            fontSize: '14px',
            lineHeight: '20px',
            color: '#6B7280'
        }),
        menuList: (styles) => ({
            ...styles,
            background: '#E3EAF9',
            border:'none',
            borderRadius: '0',
            overflowY: 'auto',
            height: 'auto',
            maxHeight: '80px'
        }),
        placeholder: (styles) => ({...styles,
            fontSize: '14px',
            lineHeight: '20px',
            color: '#9ca3af'
        })
    }

    const customNoOptionMessage = () => {
        return "Sin Opciones"
    }

    function handleChange(selectedReason) {
        setSelected(selectedReason.label);
    }

    return (
        <div className="flex flex-row px-4 justify-center w-full h-full -z-0 items-center">
            <div className='py-2 px-3 text-left flex justify-end w-80 h-16 items-center text-sm bg-primary-200 text-white rounded-xl form1:text-xl lg:w-2/4 max-w-4xl z-10 sm:w-3/4'>
                <Select className='hidden lg:block w-32 h-10 text-sm md:text-base focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'
                    noOptionsMessage={customNoOptionMessage}
                    placeholder="Filtro" 
                    options={props.options?.map((option, index) => ({value:index, label: option}))}
                    onChange={handleChange}
                    styles={customDropDown}
                />

                <Select className='lg:hidden w-[85px] mr-1 h-10 text-sm md:text-base focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'
                    noOptionsMessage={customNoOptionMessage}
                    placeholder="Filtro" 
                    options={props.options?.map((option, index) => ({value:index, label: option}))}
                    onChange={handleChange}
                    styles={customDropDownMobile}
                />
                <input id="searchInput" onChange={(ev) => {props.storage(ev.target.value)}} type={"text"} placeholder="Búsqueda" value={props.value} 
                className="px-2 py-2 w-44 h-10 text-sm  bg-white text-navFont-100 form1:text-lg lg:text-lg focus:outline-none lg:w-11/12 sm:w-11/12"/>
                <button className="w-8 h-10 bg-primary-100 rounded-r-lg lg:w-10 hover:bg-primary-400" onClick={props.function} id={"searchBtn"}> 
                    <MagnifyingGlassIcon className="h-6 w-8" aria-hidden="true"/>
                </button>
            </div>
        </div>
    )
}

export default SearchBar;